import type { FC } from 'react'
import type { CellProps } from '../../../interfaces'

import Popover from 'antd/lib/popover'

import '../../../css/PopoverCell.scss'

type IPopover = CellProps

const PopoverCell: FC<IPopover> = ({ title }) => {
  const content = (
    <div className='popover-content'>
      <p>{title}</p>
    </div>
  )
  return (
    <div className='custom-cell popover'>
      {title !== '' && title != null && title.length > 25 ? (
        <Popover content={content}>{`${title.slice(0, 25)}...`}</Popover>
      ) : (
        <div className='null'>{title}</div>
      )}
    </div>
  )
}

export default PopoverCell
